<div class="dialog-container">
  <!-- Enhanced Dialog Header -->
  <div class="dialog-header">
    <div class="header-content">
      <h2 mat-dialog-title>Assign Modules to {{ tenant.name }}</h2>
      <p class="header-subtitle">Select and manage module assignments for this tenant</p>
    </div>
    <button mat-icon-button (click)="onCancel()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
  <mat-dialog-content class="dialog-content">
    <div class="assignment-content">
      <!-- Search and Actions Section -->
      <div class="search-actions-wrapper">
        <div class="search-section">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Search modules</mat-label>
            <input matInput 
                   [(ngModel)]="searchTerm"
                   placeholder="Search by name, description, or type...">
            <mat-icon matPrefix>search</mat-icon>
            @if (searchTerm) {
              <button matSuffix mat-icon-button (click)="searchTerm = ''">
                <mat-icon>close</mat-icon>
              </button>
            }
          </mat-form-field>
        </div>
        
        <div class="bulk-actions">
          <button mat-raised-button class="btn-primary btn-action" (click)="assignAll()" [disabled]="isLoading">
            <mat-icon>done_all</mat-icon>
            <span>Assign All</span>
          </button>
          <button mat-raised-button class="btn-secondary btn-action" (click)="unassignAll()" [disabled]="isLoading">
            <mat-icon>remove_done</mat-icon>
            <span>Unassign All</span>
          </button>
          <button mat-raised-button class="btn-success btn-action" (click)="activateAll()" [disabled]="isLoading">
            <mat-icon>check_circle</mat-icon>
            <span>Activate All</span>
          </button>
          <button mat-raised-button class="btn-warning btn-action" (click)="deactivateAll()" [disabled]="isLoading">
            <mat-icon>pause_circle</mat-icon>
            <span>Deactivate All</span>
          </button>
        </div>
      </div>

      <!-- Modules Grid -->
      <div class="modules-grid">
        @for (module of filteredModules; track module.id) {
          <mat-card class="module-card" [class.assigned]="isModuleAssigned(module.id)">
            <mat-card-header>
              <div mat-card-avatar class="module-avatar">
                <mat-icon>{{ module.icon || 'apps' }}</mat-icon>
              </div>
              <mat-card-title>{{ module.name }}</mat-card-title>
              <mat-card-subtitle>{{ module.type || 'No Type' }}</mat-card-subtitle>
            </mat-card-header>
            
            <mat-card-content>
              <p class="description">{{ module.description || 'No description available' }}</p>
              
              <div class="module-badges">
                <mat-chip-listbox>
                  <mat-chip [class]="module.status === 'active' ? 'status-active' : 'status-inactive'">
                    <mat-icon matChipAvatar>{{ module.status === 'active' ? 'check_circle' : 'cancel' }}</mat-icon>
                    {{ module.status | titlecase }}
                  </mat-chip>
                  @if (module.type) {
                    <mat-chip class="type-chip">
                      <mat-icon matChipAvatar>category</mat-icon>
                      {{ module.type }}
                    </mat-chip>
                  }
                  @if (module.isCore) {
                    <mat-chip class="core-module">
                      <mat-icon matChipAvatar>star</mat-icon>
                      Core Module
                    </mat-chip>
                  }
                </mat-chip-listbox>
              </div>

              @if (isModuleAssigned(module.id)) {
                <div class="assignment-status">
                  <mat-chip class="assigned-chip">
                    <mat-icon matChipAvatar>check_circle</mat-icon>
                    Assigned
                  </mat-chip>
                  @if (getAssignedModule(module.id)?.isActive) {
                    <mat-chip class="active-chip">
                      <mat-icon matChipAvatar>play_circle</mat-icon>
                      Active
                    </mat-chip>
                  } @else {
                    <mat-chip class="inactive-chip">
                      <mat-icon matChipAvatar>pause_circle</mat-icon>
                      Inactive
                    </mat-chip>
                  }
                </div>
              }
            </mat-card-content>
            
            <mat-card-actions align="end">
              @if (isModuleAssigned(module.id)) {
                <button mat-button 
                        color="accent" 
                        (click)="toggleModuleStatus(module)"
                        [disabled]="isLoading">
                  <mat-icon>{{ getAssignedModule(module.id)?.isActive ? 'pause' : 'play_arrow' }}</mat-icon>
                  {{ getAssignedModule(module.id)?.isActive ? 'Deactivate' : 'Activate' }}
                </button>
                <button mat-button 
                        color="warn" 
                        (click)="toggleModuleAssignment(module)"
                        [disabled]="isLoading">
                  <mat-icon>remove</mat-icon>
                  Unassign
                </button>
              } @else {
                <button mat-raised-button 
                        color="primary" 
                        (click)="toggleModuleAssignment(module)"
                        [disabled]="isLoading">
                  <mat-icon>add</mat-icon>
                  Assign
                </button>
              }
            </mat-card-actions>
          </mat-card>
        }
      </div>

      @if (filteredModules.length === 0) {
        <div class="no-modules">
          <mat-icon>apps</mat-icon>
          <h3>No modules found</h3>
          <p>No modules match your search criteria.</p>
        </div>
      }
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">
      <mat-icon>close</mat-icon>
      Close
    </button>
  </mat-dialog-actions>
</div>
